// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageSV = {
  seo: {
    title: 'AI-transparens | pAIoneer Labs GmbH',
    description: 'Hur pAIoneer Labs GmbH använder artificiell intelligens och informerar om det: AI-assistent, märkning av AI-genererat innehåll, redaktionellt ansvar och kontaktpunkt enligt AI-förordningen.',
    keywords: 'AI-transparens, AI-förordningen, AI Act, artikel 50, märkning, AI-assistent, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'AI-transparens',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'AI-transparens',
    subtitle: 'Hur pAIoneer Labs GmbH använder artificiell intelligens och informerar om det.'
  },
  sections: [
    {
      title: 'Rättslig ram',
      paragraphs: [
        'Sedan den 2 augusti 2026 gäller transparensskyldigheterna enligt artikel 50 i förordning (EU) 2024/1689 om artificiell intelligens (AI-förordningen). I Tyskland är Bundesnetzagentur (Tysklands federala nätmyndighet) enligt KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, tysk lag om marknadskontroll av AI och främjande av innovation) marknadskontrollmyndighet och klagomålsinstans för AI-förordningen.',
        'Den här sidan beskriver vilka AI-system pAIoneer Labs GmbH använder och hur företaget informerar om dem. Hur personuppgifter behandlas i samband med detta beskrivs i integritetspolicyn.'
      ]
    },
    {
      title: 'AI-assistent i vår applikation',
      paragraphs: [
        'I vår applikation besvarar en AI-assistent dina frågor. Den är ett AI-system: dess svar genereras automatiskt av språkmodeller och kan vara felaktiga. Kontrollera viktiga uppgifter innan du grundar beslut på dem.',
        'Applikationen informerar dig om detta före din första inmatning och permanent bredvid chatten (artikel 50.1 i AI-förordningen). Dessutom är varje svar från assistenten maskinläsbart märkt som AI-genererat (artikel 50.2 i AI-förordningen).',
        'Språkmodellerna tillhandahålls via tjänsten från OpenRouter, Inc., USA.'
      ]
    },
    {
      title: 'Direkt kommunikation med AI-system',
      paragraphs: [
        'Om ett AI-system från pAIoneer Labs GmbH kommunicerar direkt med dig, till exempel i en chatt, ger det sig till känna som AI-system senast vid den första interaktionen.'
      ]
    },
    {
      title: 'Innehållet på den här webbplatsen',
      paragraphs: [
        'Texterna på den här webbplatsen granskas – även där AI-verktyg bidrar när de tas fram – av pAIoneer Labs GmbH och publiceras under företagets redaktionella ansvar (artikel 50.4 andra stycket i AI-förordningen).',
        'Bild-, ljud- eller videoinnehåll som har genererats eller ändrats med AI och som på ett vilseledande verklighetstroget sätt återger verkliga personer, platser eller händelser märker vi som artificiellt genererat eller ändrat (artikel 50.4 första stycket i AI-förordningen).'
      ]
    },
    {
      title: 'Analys med maskininlärning',
      paragraphs: [
        'Med ditt samtycke analyserar vi besöksstatistik med metoder för maskininlärning; närmare uppgifter finns i integritetspolicyn. Vi använder därvid varken känsloigenkänning eller biometrisk kategorisering (artikel 50.3 i AI-förordningen). Åtskillnaden mellan människor och automatiserade åtkomster bygger på tekniska egenskaper hos enhet, webbläsare och anslutning, inte på biometriska uppgifter.'
      ]
    },
    {
      title: 'Klagomål',
      paragraphs: [
        'Du kan vända dig med ett klagomål om en möjlig överträdelse av AI-förordningen till Bundesnetzagentur, marknadskontrollmyndigheten och klagomålsinstansen för AI-förordningen i Tyskland. Myndigheten tillhandahåller information om detta på bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Kontakt',
    description: 'För frågor om användningen av artificiell intelligens kan du nå oss via e-post.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Senast uppdaterad: 30 oktober 2026. Den tyska versionen är bindande.'
};
